import { render, staticRenderFns } from "./shareDashboard.vue?vue&type=template&id=5b52c040&scoped=true"
import script from "./shareDashboard.vue?vue&type=script&lang=js"
export * from "./shareDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b52c040",
  null
  
)

export default component.exports